var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXDreamLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 337.18 202.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#009cf7;}.cls-2{fill:#081a56;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4_copy",
    "data-name": "Layer 4 copy"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "64.13 120.2 60.87 115.53 57.58 120.19 4.45 195.42 0 201.72 7.72 201.72 30.21 201.72 32.29 201.72 33.48 200.02 75.2 140.64 76.81 138.35 75.2 136.05 64.13 120.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "78.91 61.85 36.86 2.68 35.67 1 33.6 1 11.11 1 3.37 1 7.84 7.31 60.91 82.15 64.12 86.68 67.4 82.2 78.88 66.53 80.58 64.21 78.91 61.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M306.45,26.13A97.07,97.07,0,0,0,272.58,6.52,127.74,127.74,0,0,0,231.23,0h-90l-1.49,2.11L73.39,95.85l-2,2.88,2,2.89,69.75,99,1.49,2.12h34.72l-5.55-7.87L106.08,98.76l50-70.67h75.14c22.3,0,41.21,6.55,54.68,18.94,14,12.85,21.36,31.64,21.36,54.33,0,22.45-7.51,41.15-21.71,54.07a69.41,69.41,0,0,1-23.91,14,91.63,91.63,0,0,1-30.42,4.91H209.72V102.26H181.39V202.72h49.85c30.33,0,56.37-9.07,75.32-26.24,20-18.15,30.62-44.12,30.62-75.12S326.54,44.27,306.45,26.13Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXDreamLogo);
export default __webpack_public_path__ + "static/media/XDream Logo.db1ce3ca83cb22c15b2c0b623af1f058.svg";
export { ForwardRef as ReactComponent };